export const InstallingLoader = (
    <svg width="25" height="25" viewBox="0 0 100 100">
    <g transform="translate(50,50)">
      <g transform="scale(1)">
        <circle cx="0" cy="0" r="50" fill="#687c93"></circle>
        <circle cx="0" cy="-26" r="12" fill="#ffffff" transform="rotate(161.634)">
          <animateTransform attributeName="transform" type="rotate" calcMode="linear"
            values="0 0 0;360 0 0" keyTimes="0;1" dur="1s" begin="0s"
            repeatCount="indefinite"></animateTransform>
        </circle>
      </g>
    </g>
  </svg>
);

export const RedHeart = (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M17.5645 3.27888C17.2852 2.63724 16.8825 2.0558 16.379 1.56709C15.875 1.07693 15.2808 0.6874 14.6288 0.419693C13.9526 0.140996 13.2274 -0.0016576 12.4952 1.45314e-05C11.468 1.45314e-05 10.4658 0.279111 9.59485 0.806293C9.38649 0.932404 9.18855 1.07092 9.00103 1.22184C8.81351 1.07092 8.61557 0.932404 8.40721 0.806293C7.53628 0.279111 6.53408 1.45314e-05 5.50688 1.45314e-05C4.76721 1.45314e-05 4.05046 0.140597 3.3733 0.419693C2.71906 0.688453 2.12941 1.07505 1.6231 1.56709C1.11887 2.05524 0.716078 2.63683 0.43755 3.27888C0.147934 3.94665 0 4.65576 0 5.38554C0 6.07398 0.141683 6.79136 0.422965 7.52115C0.658409 8.13103 0.995947 8.76365 1.42725 9.40247C2.11066 10.4134 3.05035 11.4678 4.21715 12.5366C6.1507 14.3084 8.06551 15.5323 8.14677 15.5819L8.64057 15.8961C8.85935 16.0346 9.14063 16.0346 9.35941 15.8961L9.85321 15.5819C9.93447 15.5302 11.8472 14.3084 13.7828 12.5366C14.9496 11.4678 15.8893 10.4134 16.5727 9.40247C17.004 8.76365 17.3437 8.13103 17.577 7.52115C17.8583 6.79136 18 6.07398 18 5.38554C18.0021 4.65576 17.8541 3.94665 17.5645 3.27888Z"
          fill="url(#paint0_linear_1465_710)"
      />
      <defs>
          <linearGradient id="paint0_linear_1465_710" x1="9" y1="0" x2="9" y2="16" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FF3939" />
              <stop offset="1" stop-color="#D819DC" />
          </linearGradient>
      </defs>
  </svg>
);
